import React from "react";

import { css, cx } from "@emotion/css";

import { FontSizes } from "@/assets/fonts.ts";
import { Icons } from "@/assets/icons.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Message } from "@/models/MessagingModel.ts";
import { Queries } from "@/queries/Queries.ts";
import { Button } from "@/uiKit/atoms/Button.tsx";

export type DeleteMessageProps = {
  message: Message;
  hovering: boolean;
  userIsSender: boolean;
  className?: string;
};

export const DeleteMessage: React.FC<DeleteMessageProps> = ({ message, hovering, userIsSender, className }) => {
  const styles = useStyles(makeStyles);
  const deleteMessage = Queries.messaging.useDeleteMessage();

  if (!userIsSender || message.deleted) {
    return null;
  }

  return (
    <div className={cx(styles.container, { [styles.hidden]: !hovering }, className)}>
      <Button
        variant="text"
        data-action="delete-message"
        className={styles.button}
        startIcon={<Icons.trash className={styles.icon} />}
        onClick={() => {
          deleteMessage.mutate({
            patientId: message.subjectId,
            messageId: message.id,
          });
        }}
      />
    </div>
  );
};

const makeStyles = () => ({
  container: css({
    cursor: "pointer",
    alignSelf: "center",
    transition: "opacity 0.3s ease-in-out",
  }),
  icon: css({
    width: FontSizes.body,
    height: FontSizes.body,
  }),
  hidden: css({
    opacity: 0,
    pointerEvents: "none",
  }),
  button: css({
    borderRadius: "100%",
    width: FontSizes.h3,
    height: FontSizes.h3,
  }),
});
